<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增用户</h1>
            <p class="dialog-tip">注：同一代理商仅支持创建一个超管用户账号</p>
            <el-form class="form-container" :model="userInfo" :rules="userRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">姓名</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入姓名"  v-model="userInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">用户名</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="account">
                            <el-input placeholder="请输入用户名"  v-model="userInfo.account">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <p class="remark">注:用户将使用该用户名登录系统</p>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">密码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="password">
                            <el-input placeholder="请输入密码"  v-model="userInfo.password" type="password">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">确认密码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="password_confirm">
                            <el-input placeholder="请输入密码"  v-model="userInfo.password_confirm" type="password">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">代理商</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="factor_id">
                            <factor-admin-complete v-model="userInfo.factor_id" clearable></factor-admin-complete>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">权限站点</span>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" >
                            <el-input placeholder="请输入权限站点"  v-model="userInfo.sites_str" disabled>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { addFactorAdmin } from '@/service/user'
    import {validatePassword, validateMobile} from '@/utils/validate'
    import {validateChat} from '@/utils/validate'
    import FactorAdminComplete from "../../../../components/auto-complete/factor-admin-complete";
    export default {
        name: "add",
        components: {
            PopoverRight,
            FactorAdminComplete
        },
        props: {
            callback: Function
        },
        data () {
            let validPasswordConfirm = (rule,value,callback) => {
                if (!value || value != this.userInfo.password) {
                    callback(new Error("确认密码与密码不一致"))
                } else {
                    callback()
                }
            }
            return {
                userInfo: {
                    name: '',
                    account: '',
                    password: '',
                    password_confirm: '',
                    factor_id : '',
                    factor_name : '',
                    sites_str : '',
                },
                factors : [],
                userRules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { min: 2, max: 25, message: '请输入2-25个字符的姓名', trigger: 'blur' },
                        {validator:validateChat,type:4, trigger: 'blur',result:'姓名'}
                    ],
                    factor_id: [
                        { required: true, message: '请选择代理商', trigger: 'blur' }
                    ],
                    password : [
                        { validator:validatePassword, result: '密码',trigger: 'blur' },
                        { min: 8, max: 25, message: '请输入8-25个大小写字母加数字组合的密码', trigger: 'blur' },
                    ],
                    password_confirm : [
                        { validator:validPasswordConfirm, trigger: 'blur' }
                    ],
                    account: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { min: 6, max: 25, message: '请输入6-25个字符的用户名', trigger: 'blur' },
                        {validator:validateChat, type:6, trigger: 'blur',result:'用户名'}
                    ],
                },
            }
        },
        methods : {
            async open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
            },
            resetForm () {
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
                this.userInfo = {
                    name: '',
                    account: '',
                    password: '',
                    password_confirm: '',
                    factor_id : '',
                    factor_name : '',
                    sites_str : '',
                }
                this.factors = []
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let query = {
                            account : this.userInfo.account,
                            password : this.userInfo.password,
                            name : this.userInfo.name,
                            factor_id : this.userInfo.factor_id,
                        }
                        addFactorAdmin(query).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.context ? err.context[0] : err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })

                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>
.dialog-tip{
    margin-top: 20px;
    padding: 10px;
    background-color: #f0eeee;
}
</style>
